/*
 *
 * HEADER JS
 *
 */

/**
 * Refresh dropdown magasin
 */
window.refreshDropdownMagasin = function (coords, favoris, proximite) {

  coords = typeof coords !== 'undefined' ? coords : null;
  favoris = typeof favoris !== 'undefined' ? favoris : true;
  proximite = typeof proximite !== 'undefined' ? proximite : true;

  var lat = coords !== null ? coords.latitude : null;
  var lng = coords !== null ? coords.longitude : null;

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });

  $.ajax({
    url: route('ajax.dropdown.magasin'),
    data: {
      lat: lat,
      lng: lng,
      favoris: favoris,
      proximite: proximite
    },
    dataType: 'json',
    method: 'POST'
  }).done(function (response) {

    if (response.result == 1) {

      if (response.html.favoris) {

        $('#dropdown-magasin-favoris').replaceWith(response.html.favoris);
      }

      if (response.html.proximite) {

        $('#dropdown-magasin-proximite').replaceWith(response.html.proximite);
      }
    }
  });
}

$(document).ready(function () {

  // Au chargement on vire le dernier search execute
  localStorage.removeItem('searchtext');
  var recherche_en_cours = false;

  $('#searchInput_0').keypress(function(e) {
    if(recherche_en_cours) {
      e.preventDefault();
    }
  });

  function setRechercheEnCours(value) {
      recherche_en_cours = value;
      if(recherche_en_cours) {
        $('#search_btn_header').html('sync');
        $('.js-form-search-header').css('background-color','lightyellow');
      } else {
        $('#search_btn_header').html('search');
        $('.js-form-search-header').css('background-color','transparent');
      }
  }

  function triggerMatching(search, record) {
    //Gestion avec capitale au debut
    var sMin = record.match(search.toLowerCase().trim());
    var sCap = record.match(search.substr(0,1).toUpperCase()+search.substr(1).toLowerCase());
    var st = record;
    if(sMin != null) {
      var replacement = `<mark>${sMin[0]}</mark>`;
      st = st.replace(sMin[0], replacement);
    }
    if(sCap != null) {
      replacement = `<mark>${sCap[0]}</mark>`;
      st = st.replace(sCap[0], replacement);
    }
    return st;
  }

  // let sel_mag_btn = $('.mag_selected_btn');

  // if(sel_mag_btn.length > 0) {
  // console.log('TEST', sel_mag_btn)
  $(document).on('click', '.js-remove-mag', function (e) {
    e.preventDefault();
    e.stopPropagation();
    let $dataId = $(this).attr('data-id');
    let $dataText = $(this).attr('data-original');

    let $self = $(this);

    let deselectMagasinSession = route('deselect.magasin.session').template;
    deselectMagasinSession = deselectMagasinSession.replace('{magasinId}', $dataId)

    $.ajax({
        url: deselectMagasinSession,
        method: 'GET',
      })
      .done(function (data) {
        let $allRemoveTag = $(document).find('.js-remove-mag');
        $self.trigger('reinit:session:mag');
        $.each($allRemoveTag, function (i, tag) {
          $(tag).parent().find('.txt').text($dataText);
          $(tag).remove();
          $(tag).parent().removeClass('mag_selected_btn')
        })

        //on pète le cache du slider si on retire un magasin en favori.
        // si nous virons la date ou la dernière requete à été effectuée alors le cache est invalidé.
        let checkSliderDate = localStorage.getItem('ajaxSliderDate');
        if(checkSliderDate != null) {
          localStorage.removeItem('ajaxSliderDate');
        }

        let magToDeleteFavInList = $('.mag-fav[data-mid="'+ $dataId +'"]')

        if(magToDeleteFavInList.length > 0) {
          magToDeleteFavInList.find('.js-toggleMagInFavoris').trigger('click');
        }

        $('#bHeaderMobile').remove();

        if(window.location.pathname === '/'+Lang.locale) {
            // on force le reload de la page
            window.location.reload();
        }
      })
      .fail(function (err) {
        console.log('whoops', err);
      })
  })
  // }

  $(document).on('click', '#removeFavori', function(e) {
    e.preventDefault();
    e.stopPropagation();
    $('#btnMagHeader .js-remove-mag').trigger('click');
  })

  let hasSearchBars = $('.head .search-input');
  const autoComplete = require("@tarekraafat/autocomplete.js");

  if (hasSearchBars.length > 0) {

    hasSearchBars.each((i, el) => {
      // @todo url
      console.log('log i', i);

      const autoCompleteJS = new autoComplete({
        data: { // Data src [Array, Function, Async] | (REQUIRED)
          src: async () => {
            // User search query
            const query = $(el).val().trim();
            let result = {};
            let searchList = [];

            let check = localStorage.getItem('searchtext', query);

            if(check != null) {
              check = check.trim();
            }

            console.log('check query', check)
            console.log('query', query)
            console.log('diff', check != query)
            console.log('equality', check == query)


            var url = route('ajax.produit.presearch', {
              'lang' : Lang.locale,
              'text': query,
              'nbResult': i == 0 ? 3 : 2

            }).toString();

            if(check != query) {
              try {
                setRechercheEnCours(true);
                result = await $.ajax({
                  url: url,
                  type: 'GET',
                  cache: false
                });
              }
              catch(e) {
              }
              setRechercheEnCours(false);
              localStorage.setItem('searchtext', query);
            }


            let haveKeys = Object.keys(result);
            haveKeys = haveKeys.reverse();
            console.log('result', result)

            if(haveKeys.length > 0) {

              haveKeys.forEach((keyable) => {
                let isProduit = keyable == 'produits';
                let count = result[keyable].length;
                result[keyable].forEach((resultObject, index) => {

                  if(isProduit) {
                    if(typeof resultObject.categorie.niveau_3.libelle != "undefined") {
                        var categ = resultObject.categorie.niveau_3;
                    } else if(typeof resultObject.categorie.niveau_2.libelle != "undefined") {
                        var categ = resultObject.categorie.niveau_2;
                    } else {
                      var categ = resultObject.categorie.niveau_1;
                    }
                  }

                  let object = {
                    'id' : isProduit ? resultObject.id : resultObject.categ.id,
                    'label' : isProduit ? resultObject.titre.toLowerCase() : resultObject.label_produit.substr(0,1).toUpperCase()+resultObject.label_produit.substr(1).toLowerCase(),
                    'desc' : isProduit ? categ.libelle.substr(0,1).toUpperCase()+categ.libelle.substr(1).toLowerCase() : Lang._i("presearch.dans_categ")+" "+resultObject.categ.libelle.toLowerCase(),
                    'isProduit' : isProduit,
                    'url' : isProduit ? resultObject.url : resultObject.categ.seo.alternate[Lang.locale],
                    'isLast' : count == index + 1,
                  }

                  if(isProduit) {
                    object.image = resultObject.images[0].thumb_prd;
                    object.prix = (resultObject.prix_centimes / 100)+'€'
                  }

                  searchList.push(object)
                })

              })
            }

            console.log('searchList', searchList)


            return searchList;
          },
          filter : (list) => {
            // by default the script filter on fetched entries..
            console.log('list in filtering', list)
            return list;
          },
          keys: ['label'],
          cache: false
        },
        // trigger: (query) => {

        //   localStorage.setItem('searchtext_'+i, query);
        //   console.log('TRIGGERING..', query);
        //   return query.replace(/ /g, "").length; // Returns "Boolean"
        // },
        selector: "#searchInput_"+i, // Input field selector              | (Optional)
        observer: true, // Input field observer | (Optional)
        threshold: 3, // Min. Chars length to start Engine | (Optional)
        debounce: 300, // Post duration for engine to start | (Optional)
        searchEngine: function(query, record) {
          // console.log('query', query)
          // console.log('record', record)
          // we disable search filtering but we need to make hightlight for categories..
          return 1;
        }, // Search Engine type/mode           | (Optional)
        resultsList: { // Rendered results list object      | (Optional)
          'class' : 'list-group',
          element: (list, data) => {

            if (data.results.length == 0) {
              const info = document.createElement("li");
              info.className = 'list-group-item border-0';
              info.innerHTML = Lang._i('presearch.noresult');
              list.prepend(info);
            }

          },
          noResults: true,
          maxResults: i == 0 ? (3 * 2) : (2 * 2),
          tabSelect: true
        },
        resultItem: { // Rendered result item            | (Optional)
          class : 'list-group-item px-2 pt-2 pb-1 border-0',
          element: (item, data) => {
            // Modify Results Item Style
            console.log('item', item)
            console.log('data', data)
            // Modify Results Item Content

            const query = $(el).val();

            console.log('custom matching', data.value.label.match(query.toLowerCase().trim()))

            let tpl = `<div class="row no-gutters align-items-center">`;

            if(data.value.isProduit) {
              tpl += `<div class="col-2"><img class="img-fluid rounded overflow-hidden" alt="product id ${data.value.id}" src="${data.value.image}" /></div>`;
            }

            tpl += `<div class="${data.value.isProduit ? 'col-10 pl-2' : 'col-12'}">

              <p style="color: #1D1D1B" class="${data.value.isProduit ? 'font-weight-bold text-uppercase' : 'is-matchable'} mb-0">${data.value.isProduit ? data.value.label :  triggerMatching(query, data.value.label) }</p>
              <div class="d-flex align-items-center justify-content-between">
                <p style="color: #9B9B9B" class="small mb-0">${data.value.desc}</p>
                <p style="color: #1D1D1B" class="${data.value.prix ? '' : 'd-none'} h6 mb-0">${data.value.prix ? data.value.prix : ''}</p>
              </div>
              <hr style="border-color: #EFEFEE" class="${data.value.isProduit && !data.value.isLast ? '' : 'd-none'} mb-0 mt-2">
              
            </div>`;


            item.innerHTML = tpl;
          },
          highlight: true
        },
        events: {
          input: {
            focus: () => {
              const query = $(el).val();
              if (query.length) autoCompleteJS.open();
            }
          }
        }
      });

      autoCompleteJS.input.addEventListener("selection", function (event) {
        const feedback = event.detail;
        autoCompleteJS.input.blur();
        // Prepare User's Selected Value
        const selection = feedback.selection.value.label;
        // Replace Input value with the selected value
        autoCompleteJS.input.value = selection;
        // Console log autoComplete data feedback

        window.location.href = feedback.selection.value.url;
      });

      console.log(autoCompleteJS)

      autoCompleteJS.input.addEventListener("open", function (event) {
        $(el).parent().parent().parent().addClass('is_open');
        let width = $(el).parent().parent().parent().outerWidth();
        $(autoCompleteJS.list).css('width', width)

        if(i == 1) {
          $('.search-form-container').css('transform', '')
        }
      });

      autoCompleteJS.input.addEventListener("close", function (event) {
        $(el).parent().parent().parent().removeClass('is_open');
        // $(autoCompleteJS.list).css('width', '');
      });
    })

  }




  $(document).on('reinit:session:mag', function () {
    if ($('body .v3_magasins').length == 0) {
      localStorage.setItem('need-refresh', true);
    }
  })

  skrinkBarMagFavorisText();

  $(window).on('load', function () {
    $('body').removeClass("body-on-load");
  });

  // SWITCH BETWEEN "ACHAT" & VENTE
  var btnGroupMobile = $('.btn-group-mobile-js');
  var btnSwitch = $(btnGroupMobile).find('.btn');
  var btnAchatMobile = $('.btn-achat-mobile-js');
  var btnVenteMobile = $('.btn-vente-mobile-js');

  var tlSwitchChoice = new TimelineMax({
    paused: true
  });
  tlSwitchChoice.fromTo('.navigation-mobile', 0.3, {
    x: "0%",
    ease: Circ.easeInOut
  }, {
    x: "-100%",
    ease: Circ.easeInOut
  }, "+=0.1");
  tlSwitchChoice.fromTo('.navigation-mobile-vente', 0.3, {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    y: 0,
    display: "none",
    x: "100%",
    ease: Circ.easeInOut
  }, {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    display: "block",
    x: "0%",
    y: 0,
    ease: Circ.easeInOut
  }, "+=0.1");

  //ACHAT
  $(btnAchatMobile).on('click', function (e) {
    e.preventDefault();
    if ($(this).hasClass('active')) {
      return false;
    } else {
      $(btnSwitch).removeClass('active');
      $(this).addClass('active');
      tlSwitchChoice.timeScale(3).reverse();
    }
  });

  // VENTE
  $(btnVenteMobile).on('click', function (e) {
    e.preventDefault();
    if ($(this).hasClass('active')) {
      return false;
    } else {
      $(btnSwitch).removeClass('active');
      $(this).addClass('active');
      tlSwitchChoice.timeScale(3).play();
    }
  });

  // NAVIGATION MOBILE



  //DROPDOWN


  //COUNTRY DROPDOWN
  $('.custom-dropdown-toggle').on('click', function (e) {

    e.preventDefault();
    $('.custom-dropdown-country').stop().slideToggle();

  });

  var ShowMegamenu = new TimelineMax();
  // var menuTransition = new TimelineMax();
  var submenuTransition = new TimelineMax();


  let MenuGenerator = require('./menu-generator.js').default;
  let MobileGenerator = require('./mobileGenerator').default;

  let menu = new MenuGenerator({
    locale: Lang.getLocale()
  })

  let menuMobile = new MobileGenerator({
    locale: Lang.getLocale()
  })
  menu.initialize();
  menuMobile.initialize(); // menuD.initialize();


  $(window).on('scroll', function (e) {
    // console.log('scroll')
    let scrollTop = $(window).scrollTop();
    let navTroc = $('.topnav-troc');
    if (scrollTop > 0) {
      navTroc.addClass('is-translucent');
    } else {
      navTroc.removeClass('is-translucent');
    }
  })




  // menuM.initialize();







  // $('.dropdown-show-img').on('mouseenter', function (e) {
  //   // do something…

  //   var $img_el = $(this).find('.dropdown-menu .wp-post-thumbnail');
  //   var $img_el_holder = $(this).find('.dropdown-menu .wp-post-thumbnail-holder');

  //   ShowMegamenu.to($img_el_holder, 0.1, {height: $img_el.outerHeight(true) + 'px', ease: Circ.easeInOut});


  // }).on('mouseleave', function (e) {

  //   var $img_el = $(this).find('.wp-post-thumbnail');
  //   var $img_el_holder = $(this).find('.wp-post-thumbnail-holder');
  //   ShowMegamenu.to($img_el_holder, 0.1, {height: '0px', ease: Circ.easeInOut});
  //   $(this).removeClass('expanded')



  // })



  var dropdowns = ['.dropdown-user', '.dropdown-magasin'];

  function toggleDropdown(e) {
    let _d = $(e.target).closest('.dropdown'),
      _m = $('.dropdown-menu', _d);

    setTimeout(function () {
      let shouldOpen = e.type !== 'click' && _d.is(':hover');
      _m.prev().toggleClass('active', shouldOpen)
      _m.toggleClass('show', shouldOpen);
      _d.toggleClass('show', shouldOpen);
      $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
    }, e.type === 'mouseleave' ? 100 : 0);
  }




  dropdowns.forEach((dropdown) => {
    $('body')
      .on('mouseenter mouseleave', dropdown, toggleDropdown)
    $(document).on('click', dropdown, function (e) {
      e.stopPropagation();
    });
  });

  // Ajoute ou supprime un magasin en favoris
  $('body').on('click', '.dropdown-magasin .js-select-magasin, .dropdown-magasin .js-unselected-magasin', function (e) {

    e.preventDefault();

    var magasinId = $(this).attr('data-magasin-id');

    if ($(this).hasClass('js-select-magasin')) {

      var url = route('select.magasin', {
        'magasinId': magasinId
      }).toString();
    } else {

      var url = route('unselect.magasin', {
        'magasinId': magasinId
      }).toString();
    }

    $.ajax({
        type: 'GET',
        url: url,
        dataType: 'json'
      })
      .done(function (data) {

        if (data.result > 0) {

          refreshDropdownMagasin();
        } else if (data.result < 0) {

          $('#modal-if-not-connected').modal('toggle');
        } else {

          //console.log(data.message);
        }
      })
      .fail(function (jqXHR, textStatus, errorThrown) {

        //console.log('Selection magasin bug', errorThrown);
      });
  });
});
